import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { memo, useEffect, useRef, useState } from 'react';
import omit from 'lodash/omit';
import { FormControl, InputGroup } from '@cancercentrum/rcc-bootstrap';
import { normalize as normalizeDate } from '../utils/date';
import { useRegvarValidator } from '../hooks/useRegvarValidator';
import { useI18n } from '../i18n';
import Calendar from './Calendar';
const RegvarDatetime = (props)=>{
    const { readOnly, minDate, maxDate, calendar = true, placeholder, type = 'text', ...rest } = props;
    const [value, setValue] = useState(props.value ?? null);
    const calendarRef = useRef(null);
    const inputRef = useRef(null);
    const val = useRegvarValidator();
    const i18n = useI18n();
    useEffect(()=>{
        setValue(props.value ?? null);
    }, [
        props.value
    ]);
    const onDatePicked = (date)=>{
        setValue(date);
        props.onChange(date);
        if (inputRef.current) {
            inputRef.current.focus();
        }
    };
    const onChange = (e)=>{
        setValue(e.target.value || null);
    };
    const onBlur = (e)=>{
        const newValue = normalizeDate(e.target.value, {
            addZeroTime: rest.regvarMetadata.includeTime
        });
        props.onChange(newValue || null);
    };
    const openCalendar = ()=>{
        if (!props.disabled && calendar) {
            calendarRef.current?.open();
        }
    };
    const onKeyDown = (e)=>{
        if (calendar) {
            if (e.key === 'ArrowDown') {
                if (!calendarRef.current?.isOpen()) {
                    e.preventDefault();
                    e.stopPropagation();
                }
                openCalendar();
            }
        }
    };
    const propsToPass = omit(rest, [
        'regvarMetadata',
        ...val.getValidationPropNames([
            'required'
        ])
    ]);
    const placeholderText = placeholder ? placeholder : i18n.t('regvar.date.placeholder');
    if (readOnly) {
        return /*#__PURE__*/ _jsx("div", {
            className: "form-control-plaintext",
            children: value
        });
    }
    return /*#__PURE__*/ _jsx("div", {
        className: "regvar-datetime",
        children: /*#__PURE__*/ _jsxs(InputGroup, {
            children: [
                /*#__PURE__*/ _jsx(FormControl, {
                    ...propsToPass,
                    type: type,
                    placeholder: placeholderText,
                    className: "regvar-datetime__input",
                    value: value || '',
                    onChange: onChange,
                    onBlur: onBlur,
                    onKeyDown: onKeyDown,
                    ref: inputRef
                }),
                calendar && /*#__PURE__*/ _jsx(InputGroup.Text, {
                    onClick: openCalendar,
                    className: "regvar-datetime__toggle-calendar",
                    children: /*#__PURE__*/ _jsx(Calendar, {
                        date: value,
                        onDatePicked: onDatePicked,
                        disabled: rest.disabled,
                        minDate: minDate ?? null,
                        maxDate: maxDate ?? null,
                        includeTime: rest.regvarMetadata.includeTime,
                        ref: calendarRef
                    })
                })
            ]
        })
    });
};
export default /*#__PURE__*/ memo(RegvarDatetime);
